export default "__VITE_ASSET__1d364f9d__"